import styled, { css } from 'styled-components'
import { themeColor, UISizes, UITypes } from 'LibNeo'
import { Link } from 'react-router-dom'

const sizes = {
	[UISizes.EXTRASMALL]: css`
		width: 10px;
		height: 10px;
	`,
	[UISizes.SMALL]: css`
		width: 16px;
		height: 16px;
	`,
	[UISizes.NORMAL]: css`
		width: 20px;
		height: 20px;
	`,
	[UISizes.BIG]: css`
		width: 24px;
		height: 24px;
	`,
	[UISizes.RECTANGLE]: css`
		width: 48px;
		height: 24px;
	`,
	[UISizes.LARGE]: css`
		width: 24px;
		height: 28px;
	`,
}

const types = {
	[UITypes.PRIMARY]: themeColor('emerald', 5),
	[UITypes.MAIN]: themeColor('extraBackground3'),
	[UITypes.GREY]: themeColor('gray', 5),
	[UITypes.GREY_LIGHT]: themeColor('gray', 4),
	[UITypes.WARNING]: themeColor('gold', 5),
	[UITypes.DANGER]: themeColor('pink', 5),
	[UITypes.PASSIVE]: themeColor('gray', 5),
	[UITypes.BLUE]: themeColor('blue', 5),
	[UITypes.WHITE]: themeColor('white'),
	[UITypes.BLUE]: themeColor('gray', 6),
	[UITypes.VIOLET]: themeColor('violet'),
}

const typeWithAction = {
	[UITypes.PRIMARY]: themeColor('emerald', 7),
	[UITypes.MAIN]: themeColor('emerald', 7),
	[UITypes.GREY]: themeColor('gray', 5),
	[UITypes.GREY_LIGHT]: themeColor('gray', 4),
	[UITypes.WARNING]: themeColor('gold', 7),
	[UITypes.DANGER]: themeColor('pink', 7),
	[UITypes.PASSIVE]: themeColor('gray', 8),
	[UITypes.BLUE]: themeColor('blue', 7),
	[UITypes.WHITE]: themeColor('white'),
	[UITypes.BLUE]: themeColor('gray', 6),
}

const iconComponentCss = css`
	position: relative;
	display: inline-block;
	vertical-align: text-top;
	overflow: hidden;
	text-align: center;
	line-height: normal;
`

export const IconComponentStyled = styled.span<{
	size: UISizes
	disabled: boolean
}>`
	${iconComponentCss}
	${({ size }) => sizes[size]}
	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
		`}
`

export const IconLinkStyled = styled(Link)<{ size: UISizes }>`
	${iconComponentCss}
	${({ size }) => sizes[size]}
`

export const IconStyled = styled.svg<{
	size: UISizes
	type: UITypes
	isAction: boolean
	disabled: boolean
}>`
	display: inline-block;
	${({ size }) => sizes[size]}
	${({ type }) => css`
		fill: ${() => types[type]};
	`}
	${({ isAction, disabled }) =>
		isAction &&
		!disabled &&
		css<{ type: UITypes }>`
			&:hover {
				${({ type }) => css`
					fill: ${() => typeWithAction[type]};
				`}
				cursor: pointer;
			}
		`}
	
	
	${({ disabled }) =>
		disabled &&
		css`
			,
			&:hover {
				fill: ${themeColor('gray', 8)};
				cursor: default;
			}
		`}
`
